import {
    createColumnDate,
    createColumnInput,
    createColumnInputNumber,
    createColumnRadioGroup,
    createColumnSelect
} from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import { has } from "../../../../utils/menu-context";
import { required } from "../../../../utils/validate";
import lodash from "lodash";
import moment from "moment";

export const callUserObjective = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_OBJECTIVE", value: searchQuery })
        .then(items => items.filter(item => ["1", "2", "4", "5"].includes(item.key)));
export const callHaz = ({ searchQuery, operationId, userInfo }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false }
    ];
    if (operationId) {
        where.push({ name: "hazLicenseDetails.refHazLicense.refOperation.id", type: "UUID", operator: "=", value: operationId });
    }
    if (userInfo) {
        where.push({
            name: "hazLicenseDetails.refHazLicense.refUserCompany.id",
            type: "UUID",
            operator: "=",
            value: userInfo?.refParent?.id || userInfo?.id
        });
    }
    if (searchQuery) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/transaction/haz/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "version", "approveCode", "refHazObject.id", "refHazObject.nameTh", "tradeNameTh", "refOperation.id", "refOperation.version", "refOperation.value", "effectiveDate", "expireDate"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }, { name: "effectiveDate", type: "DESC" }]
            }
        })
        .then(page => page.data);
};
export const callHazFull = ({ id, approveCode, quotaOperationKey, refUserCompanyId }) => {
    const userInfo = store.state.resource.auth.info?.user;
    const where = [{ name: "isTemp", type: "Boolean", operator: "=", value: false }];
    if (approveCode) {
        where.push({ name: "approveCode", type: "String", operator: "=", value: approveCode });
    } else {
        where.push({ name: "id", type: "UUID", operator: "=", value: id });
    }
    return store
        .dispatch("resource/v1/transaction/haz/search", {
            criteria: {
                isDistinct: true,
                select: ["*"],
                page: 0,
                size: 100,
                where: where,
                sort: [{ name: "effectiveDate", type: "DESC" }],
                children: [
                    {
                        name: "hazLicenseDetails",
                        isDistinct: true,
                        select: ["*", "refHazLicense.*"],
                        page: 0,
                        size: 100,
                        where: [
                            { name: "refHazLicense.isActive", type: "Boolean", operator: "=", value: true },
                            { name: "refHazLicense.isTemp", type: "Boolean", operator: "=", value: false },
                            { name: "refHazLicense.refOperation.key", type: "String", operator: "=", value: quotaOperationKey },
                            { name: "refHazLicense.refUserCompany.id", type: "UUID", operator: "=", value: refUserCompanyId || userInfo?.refParent?.id || userInfo?.id },
                            { name: "refHazLicense.effectiveDate", type: "Date", operator: "<=", value: moment().format("YYYY-MM-DD") },
                        ],
                        sort: [{ name: "refHazLicense.effectiveDate", type: "DESC" }]
                    }
                ]
            }
        })
        .then(page => page.data);
};
export const callUserCompany = ({ searchQuery }) => {
    const userInfo = store.state.resource.auth.info?.user;
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "active" },
        { name: "isCeo", type: "Boolean", operator: "=", value: true },
    ];

    if (!userInfo.refDepartment?.id) {
        where.push(
            { openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 1
            { name: "id", type: "UUID", operator: "=", value: userInfo?.refParent?.id || userInfo?.id },
            { logic: "OR", openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 2
            { name: "userAuthorizes.isActive", type: "Boolean", operator: "=", value: true },
            { name: "userAuthorizes.isTemp", type: "Boolean", operator: "=", value: false },
            { name: "userAuthorizes.refStatus.key", type: "String", operator: "=", value: "active" },
            { name: "userAuthorizes.refAuthorizeType.key", type: "String", operator: "=", value: "2" },
            { name: "userAuthorizes.refAuthorize.id", type: "UUID", operator: "=", value: userInfo?.refParent?.id || userInfo?.id },
            { name: "userAuthorizes.roles.refRole.name", type: "String", operator: "in", value: ["STOCK_CARD"] },

            { name: "userAuthorizes.refAuthorize.userAuthorizes.isActive", type: "Boolean", operator: "=", value: true },
            { name: "userAuthorizes.refAuthorize.userAuthorizes.isTemp", type: "Boolean", operator: "=", value: false },
            { name: "userAuthorizes.refAuthorize.userAuthorizes.refStatus.key", type: "String", operator: "=", value: "active" },
            { name: "userAuthorizes.refAuthorize.userAuthorizes.refAuthorizeType.key", type: "String", operator: "=", value: "1" },
            {
                name: "userAuthorizes.refAuthorize.userAuthorizes.refAuthorize.id",
                type: "Getpath",
                operator: "=",
                value: "id"
            },
            { closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 2
            { closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" } // 1
        );
    }

    if (searchQuery) {
        where.push(
            { openBucket: true, name: "companyNameTh", type: "String", operator: "like", value: searchQuery },
            { logic: "OR", name: "idCard", type: "String", operator: "like", value: searchQuery },
            { logic: "OR", closeBucket: true, name: "fullNameTh", type: "String", operator: "like", value: searchQuery },
        );
    }
    return store
        .dispatch("resource/v1/security/user/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "version", "companyNameTh", "companyNameEn", "fullNameTh", "fullNameEn", "refPersonType.*"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "idCard", type: "ASC" }]
            }
        })
        .then(page => page.data);
};

export const createColumns = ({ props }) => {
    const userInfo = store.state.resource.auth.info?.user;
    const columns = [
        createColumnRadioGroup({
            visible: () => false,
            title: () => " ",
            dataIndex: "quotaObjectiveKey",
            inputProp: ({ field }) => ({
                list: callUserObjective,
                optLabel: "value",
                value:field.searchValue,
                "onUpdate:value": value => {
                    field.searchValue = value;
                    if (field.columns.find(d => d.dataIndex === "refHazId")?.search?.field?.searchValue) {
                        field.columns.find(d => d.dataIndex === "refHazId").search.field.searchValue = null;
                    }
                },
            }),
            search: {
                type: "String",
                getValue: ({ value }) => value.key,
                field: {
                    rulesRef: [required],
                    colProp: () => ({ xs: 24 }),
                    formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 }, colon: false })
                }
            }
        }),
        createColumnSelect({
            visible: () => false,
            title: () => i18n.global.t("model.stockCard.refUserCompany"),
            dataIndex: "refUserCompany",
            inputProp: ({ field }) => {
                const operationId = field.columns.find(d => d.dataIndex === "quotaObjectiveKey")?.search?.field.searchValue?.id;
                return {
                    disabled: !operationId,
                    list: ({ searchQuery }) => callUserCompany({ searchQuery }),
                    renderLabel: ({ item }) => {
                        if (item.refPersonType?.key === "1") {
                            return <div>{item.idCard} - {item.companyNameTh}</div>;
                        }
                        return <div>{item.idCard} - {item.fullNameTh}</div>;
                    },
                    "onUpdate:value": value => {
                        field.searchValue = value;
                        if (field.columns.find(d => d.dataIndex === "refHazId")?.search?.field.searchValue) {
                            field.columns.find(d => d.dataIndex === "refHazId").search.field.searchValue = null;
                        }
                    },
                };
            },
            search: {
                field: {
                    rulesRef: userInfo?.refDepartment?.id ? [required] : [],
                    colProp: () => ({ xs: 24 }),
                    formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                }
            }
        }),
        createColumnSelect({
            visible: () => false,
            title: () => i18n.global.t("model.stockCard.refHazId"),
            dataIndex: "refHazId",
            inputProp: ({ field }) => {
                const operationId = field.columns.find(d => d.dataIndex === "quotaObjectiveKey")?.search?.field.searchValue?.id;
                const refUserCompany = field.columns.find(d => d.dataIndex === "refUserCompany")?.search?.field.searchValue;
                return {
                    disabled: !operationId || (userInfo?.refDepartment?.id && !refUserCompany?.id),
                    list: ({ searchQuery }) => {
                        return callHaz({
                            searchQuery,
                            operationId,
                            userInfo: refUserCompany?.id ? refUserCompany :
                                has({ menuContext: props.menuContext, key: "forMe" }) ? userInfo : null
                        }).then(data => {
                            return lodash.uniqBy(data, "approveCode");
                        });
                    },
                    optLabel: "approveCode",
                    renderLabel: ({ item }) => {
                        return <span>{item.approveCode}-{item.tradeNameTh || "ไม่มีข้อมูล"}-{item.refHazObject?.nameTh || "ไม่มีข้อมูล"}</span>;
                    },
                };
            },
            search: {
                field: {
                    rulesRef: [required],
                    colProp: () => ({ xs: 24 }),
                    formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } })
                }
            }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.stockCard.storageLocationName"),
            dataIndex: "storageLocationName",
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.stockCard.storageLocationSubName"),
            dataIndex: "storageLocationSubName",
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.stockCard.lot"),
            dataIndex: "lot",
            search: { visible: () => false },
            width: 200
        }),
        createColumnInput({
            title: () => i18n.global.t("model.stockCard.hazApproveCode"),
            dataIndex: "hazApproveCode",
            align: "center",
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.stockCard.statusName"),
            dataIndex: "statusName",
            align: "center",
            search: { visible: () => false }
        }),
        createColumnDate({
            title: () => i18n.global.t("model.stockCard.operationDatetime"),
            dataIndex: "operationDatetime",
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.stockCard.inDesc"),
            dataIndex: "inDesc",
            search: { visible: () => false }
        }),
        createColumnInputNumber({
            title: () => i18n.global.t("model.stockCard.inQty"),
            dataIndex: "inQty",
            comma: true,
            allowPrecision: true,
            maxPrecision: 2,
            inputProp: () => ({ comma: true, allowPrecision: true, maxPrecision: 2 }),
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.stockCard.outDesc"),
            dataIndex: "outDesc",
            search: { visible: () => false }
        }),
        createColumnInputNumber({
            title: () => i18n.global.t("model.stockCard.outQty"),
            dataIndex: "outQty",
            comma: true,
            allowPrecision: true,
            maxPrecision: 2,
            inputProp: () => ({ comma: true, allowPrecision: true, maxPrecision: 2 }),
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.stockCard.objectiveName"),
            dataIndex: "objectiveName",
            align: "center",
            search: { visible: () => false }
        })
    ];
    return columns;
};
